var React = require('react');

function Arrow (props) {
    return React.createElement("svg",props,React.createElement("polyline",{"points":"45.42 16.68 85.41 50 45.42 83.32","style":{"fill":"none","stroke":"#505050","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"8px"}}));
}

Arrow.defaultProps = {"viewBox":"0 0 100 100"};

module.exports = Arrow;

Arrow.default = Arrow;
